import { render, staticRenderFns } from "./SupervisorsDialog.vue?vue&type=template&id=4c3cc227&scoped=true&"
import script from "./SupervisorsDialog.vue?vue&type=script&lang=js&"
export * from "./SupervisorsDialog.vue?vue&type=script&lang=js&"
import style0 from "./SupervisorsDialog.vue?vue&type=style&index=0&id=4c3cc227&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c3cc227",
  null
  
)

export default component.exports